import React, { FunctionComponent, useState } from 'react';
import DashboardLayout from '../../../components/layout/layout';

//import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import { Alert, Box, Button, Grid, Skeleton, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useDeleteCPAdminUser, useGetCPAdminUserById } from '../../../hooks/api/user';
import AddNewUserIcon from '../../../assets/img/Add New User.png';

const AdminUserDelete: FunctionComponent = () => {
  const navigate = useNavigate();

  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<boolean>();
  const [ disabled, setDisabled ] = useState<boolean>(false);
  const { mutateAsync: deleteAdminUser } = useDeleteCPAdminUser();

  const { userId } = useParams();
  if (userId === '') {
    navigate('/admin');
  }
  const { data: adminUser, isFetched: hasFetched } = useGetCPAdminUserById(userId);

  const deleteUser = async () => {
    try {
      setDisabled(true);
      const result = await deleteAdminUser({ userId: adminUser.userId.toString() });
      if (result?.status === 200) {
        setSuccess(true)
        setTimeout(() => {
          setSuccess(false);
          navigate('/admin');
          setDisabled(false);
        }, 3000);
      } else {
        setDisabled(false);
        setError('An error occurred during login. Please try again.');
        setTimeout(() => {
          setError('');
        }, 3000);
      }
    } catch (err: any) {
      setDisabled(false);
      if (err?.response?.data?.message) {
        setError(err.response.data.message);
      } else if (err?.message) {
        setError(err.message);
      } else {
        setError('An error occurred during login. Please try again.');
      }
    }
  }

  return (
    <>
      <DashboardLayout titleIcon={<img src={AddNewUserIcon} alt="AddNewUserIcon" style={{ width: 35, height: 35 }} />} title={"Other Extranets"} initialBreadcrumbs={"Extranet"} levelBreadcrumbs={'Barksdale Admin'} breadcrumbs={'Channel Partner User Delete'} activeMenu={'admin'}>
        {
          !hasFetched ? (
            <>
              <Skeleton width="38%" />
              <Skeleton width="100%" />
              <Skeleton width="100%" />
              <Skeleton width="61%" />
            </>
          ) : (
            <>
              <Typography variant="body1" mb={3}>
                Are you sure you want to delete {adminUser.firstName} {adminUser.lastName}?
              </Typography>
              
              <Grid size={12}>
                {error && (
                  <Alert severity="error" sx={{ mt: 2 }}>
                    {error}
                  </Alert>
                )}
                {
                  success && (
                    <Alert severity="success" sx={{ mt: 2 }}>
                      User deleted successfully!
                    </Alert>
                  )
                }
              </Grid>

              <Box sx={{ mt: 3, display: "flex", alignItems: "center", gap: 3 }}>
                <Button disabled={disabled} variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', minWidth: '100px' }} onClick={(e) => deleteUser()}>
                  YES
                </Button>
                <Button disabled={disabled} variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', minWidth: '100px' }} onClick={() => navigate('/admin')}>
                  NO
                </Button>
              </Box>
            </>
          )
        }
      </DashboardLayout>
    </>
  )
};

export default AdminUserDelete;